import { render, staticRenderFns } from "./linkList.vue?vue&type=template&id=54dae211"
import script from "./linkList.vue?vue&type=script&lang=js"
export * from "./linkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports